import globalReducer, { actions as GlobalActions } from './globalReducer';
import mailReducer, { actions as MailActions } from './mailReducer';
import mailTabReducer, { actions as MailTabActions } from './mailTabReducer';
import attachmentReducer, { actions as AttachmentActions } from './attachmentReducer';
import contactReducer, { actions as ContactActions } from './contactReducer';
import tempContactReducer, { actions as TempContactActions } from './tempContactReducer';
import readCountReducer, { actions as ReadCountActions } from './readCountReducer';
import mailConfigReducer, { actions as MailConfigActions } from './mailConfigReducer';
import scheduleReducer, { actions as ScheduleActions } from './scheduleReducer';
import loginReducer, { actions as LoginActions } from './loginReducer';
import mailTemplateReducer, { actions as MailTemplateActions } from './mailTemplateReducer';
import mailProductReducer, { actions as MailProductActions } from './mailProductReducer';
import mailClassifyReducer, { actions as MailClassifyActions } from './mailClassifyReducer';
import diskReducer, { actions as DiskActions } from './diskReducer';
import diskAttReducer, { actions as DiskAttActions } from './diskAttReducer';
import strangerReducer, { actions as StrangerActions } from './strangerReducer';
import readMailReducer, { actions as ReadMailActions } from './readMailReducer';
import niceModalReducer, { actions as NiceModalActions } from './niceModalReducer';
import autoReplyReducer, { actions as AutoReplyActions } from './autoReplyReducer';
import hollowOutGuideReducer, { actions as HollowOutGuideAction } from './hollowOutGuideReducer';
import aiWriteMailReducer, { actions as AiWriteMailReducer } from './aiWriteMailReducer';
import autoUnmountReducer, { actions as AutoUnmountReducer } from './autoUnmountReducer';
import worktableReducer, { actions as WorktableActions } from './worktableReducer';
import waReducer, { actions as WaActions } from './waReducer';
import noviceTaskReducer, { actions as NoviceTaskActions } from './noviceTaskReducer';
import privilegeReducer, { privilegeActions as PrivilegeActions } from './privilegeReducer';
import edmUserReducer, { edmUserActions as EdmUserActions } from './edmUserReducer';
import expandMenuReducer, { actions as ExpandMenuActions } from './expandMenuReducer';
import customerReducer, { actions as CustomerAction } from './customerReducer';
import customerCardReducer, { CustomerCardActions } from './customerCard';
import webEntryWmReducer, { WebEntryWmActions } from './webEntryWmReducer';
import taskReducer, { TaskActions } from './taskReducer';
import facebookReducer, { FacebookActions } from './facebookReducer';
import salesPitchReducer, { actions as SalesPitchActions } from './salesPitchReducer';
import approvalFlowReducer, { ApprovalFlowActions } from './approvalFlowReducer';
import snsMarketingTaskReducer, { actions as snsMarketingTaskActions } from './snsMarketingTaskReducer';
import snsAiQuotaReducer, { actions as SnsAiQuotaActions } from './snsAiQuotaReducer';
import snsImReducer, { actions as SnsImActions } from './snsImReducer';
import configReducer, { actions as ConfigActions } from './configReudcer';
import hotKeyReducer, { actions as HotKeysActions } from './hotkeysReducer';
import noticeCenterReducer, { actions as NoticeCenterActions } from './noticeCenterReducer';
import popupReducer, { actions as PopupActions } from '../../popup_state/';
import aiStaffReducer, { actions as AiStaffActions } from './aiStaffReducer';
import aiTeamReducer, { actions as AiTeamActions } from './aiTeamReducer';
import aiAsstWmReducer, { actions as AiAsstWmActions } from './aiAsstWmReducer';
import siteReducer, { actions as SiteActions } from './siteReducer';
const rootReducer = {
    mailProductReducer,
    globalReducer,
    mailReducer,
    attachmentReducer,
    contactReducer,
    tempContactReducer,
    readCountReducer,
    scheduleReducer,
    mailConfigReducer,
    loginReducer,
    mailTemplateReducer,
    mailClassifyReducer,
    diskReducer,
    diskAttReducer,
    strangerReducer,
    readMailReducer,
    niceModalReducer,
    autoReplyReducer,
    mailTabReducer,
    hollowOutGuideReducer,
    worktableReducer,
    waReducer,
    noviceTaskReducer,
    privilegeReducer,
    edmUserReducer,
    expandMenuReducer,
    customerReducer,
    customerCardReducer,
    webEntryWmReducer,
    taskReducer,
    facebookReducer,
    aiWriteMailReducer,
    salesPitchReducer,
    snsMarketingTaskReducer,
    snsAiQuotaReducer,
    snsImReducer,
    configReducer,
    hotKeyReducer,
    noticeCenterReducer,
    popupReducer,
    autoUnmountReducer,
    approvalFlowReducer,
    aiStaffReducer,
    aiTeamReducer,
    aiAsstWmReducer,
    siteReducer,
};
const AppActions = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, GlobalActions), MailActions), AttachmentActions), ContactActions), TempContactActions), ReadCountActions), ScheduleActions), MailConfigActions), LoginActions), MailTemplateActions), MailClassifyActions), DiskActions), DiskAttActions), StrangerActions), ReadMailActions), NiceModalActions), AutoReplyActions), MailTabActions), HollowOutGuideAction), WorktableActions), WaActions), NoviceTaskActions), PrivilegeActions), EdmUserActions), ExpandMenuActions), CustomerAction), CustomerCardActions), EdmUserActions), PrivilegeActions), ExpandMenuActions), CustomerAction), MailProductActions), WebEntryWmActions), FacebookActions), SalesPitchActions), snsMarketingTaskActions), SnsAiQuotaActions), SnsImActions), TaskActions), ConfigActions), HotKeysActions), PopupActions), NoticeCenterActions), AutoUnmountReducer), ApprovalFlowActions), AiStaffActions), AiTeamActions), AiAsstWmActions), SiteActions);
export { AppActions, mailProductReducer, globalReducer, mailReducer, attachmentReducer, contactReducer, tempContactReducer, readCountReducer, scheduleReducer, mailConfigReducer, mailTemplateReducer, mailClassifyReducer, diskReducer, diskAttReducer, strangerReducer, readMailReducer, niceModalReducer, autoReplyReducer, mailTabReducer, hollowOutGuideReducer, customerCardReducer, GlobalActions, MailActions, AttachmentActions, ContactActions, TempContactActions, ReadCountActions, ScheduleActions, MailConfigActions, MailTemplateActions, MailClassifyActions, DiskActions, DiskAttActions, StrangerActions, ReadMailActions, NiceModalActions, AutoReplyActions, MailTabActions, HollowOutGuideAction, WorktableActions, WaActions, NoviceTaskActions, PrivilegeActions, EdmUserActions, ExpandMenuActions, CustomerAction, CustomerCardActions, MailProductActions, WebEntryWmActions, FacebookActions, AiWriteMailReducer, salesPitchReducer, SalesPitchActions, snsMarketingTaskReducer, snsMarketingTaskActions, SnsAiQuotaActions, SnsImActions, ConfigActions, HotKeysActions, NoticeCenterActions, PopupActions, AutoUnmountReducer, ApprovalFlowActions, AiStaffActions, AiTeamActions, AiAsstWmActions, SiteActions, };
export default rootReducer;
